import { Box } from "@mui/material";

import Navbar from "../Navbar/Navbar";
import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Layout.scss";
import Sidnavbar from "../../../../Components/Sidnavbar/Sidnavbar";
import { useDispatch } from "react-redux";
import { listSideMenuPermission } from "../../../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import Sidebar from "../SideNavbar/TutorSideNavbar";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const dispatch = useDispatch();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);


  return (
    <div className="layout">
      {/* Sidebar */}
      <div className={`layout-sidebar ${sidebarOpen ? "open" : ""}`}>
        <Sidebar />
      </div>

      {/* Main Content */}
      <div className="layout-main">
        <Navbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

        <Box
          className="layout-content"
          onClick={() => sidebarOpen && setSidebarOpen(false)}
        >
          <Outlet />
        </Box>
      </div>
    </div>
  );
};

export default Layout;
